import { useMemo } from 'react';

import { staticRoutes } from 'Deer/constants/routes';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { IntentFilters } from 'Deer/intent/components/Layout/IntentFilters.layout';
import { IntentBreadcrumbType, IntentValuesType } from 'Deer/intent/types/IntentCommonTypes';
import { useHistory, useLocation } from 'react-router-dom';

type Props = {
  breadcrumbs: IntentBreadcrumbType;
};

export type ThirdPartyIntegrationsIntentType = {
  label: string;
  onClick: () => void;
  visible: () => boolean;
  value: {
    myData?: IntentValuesType;
    team?: {
      directReports?: IntentValuesType;
      allReports?: IntentValuesType;
    };
    company?: IntentValuesType;
  };
  applicableGroupByValues?: {
    value: string;
    label: string;
  }[];
};

const PluginsIntentDropdown = ({ breadcrumbs }: Props) => {
  const { l1Module } = useRouteToNavLevels();
  const history = useHistory();
  const { pathname } = useLocation();
  // eslint-disable-next-line arrow-body-style
  const intentDropdownOptions = useMemo<Array<ThirdPartyIntegrationsIntentType>>(() => {
    return [
      {
        label: `Slack`,
        onClick: () => {
          history.push({
            pathname: staticRoutes.company.settings.plugins.slack,
          });
        },
        visible: () => true,
        value: {
          company: {
            path: staticRoutes.company.settings.plugins.slack,
            isAccessible: () => {
              // todo
            },
          },
        },
      },
      {
        label: `MS Teams`,
        onClick: () => {
          history.push({
            pathname: staticRoutes.company.settings.plugins.msteams,
          });
        },
        visible: () => true,
        value: {
          company: {
            path: staticRoutes.company.settings.plugins.msteams,
            isAccessible: () => {
              // todo
            },
          },
        },
      },
    ];
  }, [history]);

  const selectedIntent = useMemo(
    () => intentDropdownOptions.find((option) => pathname.includes(option.value[l1Module]?.path)),
    [intentDropdownOptions, l1Module, pathname]
  );

  return (
    <IntentFilters
      // @ts-expect-error options type error
      intentDropdownOptions={intentDropdownOptions.filter((option) => option.visible())}
      selectedIntent={selectedIntent?.label ?? ''}
      moduleName="Third party integration"
      intentTitle="Third party integration"
      breadcrumbs={breadcrumbs}
    />
  );
};

export { PluginsIntentDropdown };
